import { render, staticRenderFns } from "./MainContainerLayout.vue?vue&type=template&id=5f68e959"
import script from "./MainContainerLayout.vue?vue&type=script&lang=js"
export * from "./MainContainerLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports